import * as React from 'react';
const SvgOfficeMaterials = (props) => (
  <svg viewBox="0 0 124 126" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M110.891 50.428V31.802L81.265 2h-70.36C8.87 2 7.202 3.676 7.202 5.725v63.328"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M110.891 33.664H84.969c-2.037 0-3.703-1.676-3.703-3.725v-5.588M42.382 16.9H23.866v18.627h18.516V16.9Z"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M57.194 50.428H122v67.053H73.859"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M54.788 75.386H9.962C5.565 75.386 2 78.972 2 83.396v32.557c0 4.424 3.565 8.01 7.962 8.01h44.826c4.398 0 7.962-3.586 7.962-8.01V83.395c0-4.423-3.564-8.009-7.962-8.009Z"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m38.42 112.955 10.74-12.386a4.368 4.368 0 0 1 6.628 0l1.518 1.751M47.956 123.981l-9.554-11.026-6.073-7.004c-1.759-2.03-4.888-2.03-6.628 0l-6.259 7.227L10.073 124"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m7.202 99.023 1.463 1.695L19.46 113.16M38.142 97.57c4.56 0 8.258-3.72 8.258-8.307 0-4.588-3.697-8.308-8.258-8.308-4.561 0-8.258 3.72-8.258 8.308 0 4.587 3.697 8.307 8.258 8.307ZM110.891 65.328H73.859M110.891 76.504H73.859M110.891 89.542H73.859M110.891 102.58H73.859"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgOfficeMaterials;
